module.exports = __webpack_public_path__ + "img/support_b4.285adeb4.png";